import { getElement, getElements } from '../Utility/Dom'

class AuthorModal {
  private activeButton: HTMLElement | null = null
  private readonly body: HTMLElement | null
  private readonly closeButton: HTMLElement | null
  private readonly dialog: HTMLDialogElement | null
  private readonly openButtons: NodeListOf<HTMLElement>

  constructor() {
    this.body = getElement('author-modal-body')
    this.closeButton = getElement('author-modal-close')
    this.dialog = getElement('author-modal') as HTMLDialogElement | null
    this.openButtons = getElements('author-modal-open')
  }

  init(): void {
    if (this.dialog === null || this.openButtons.length === 0) return
    this.addEvents()
  }

  private addEvents(): void {
    this.openButtons.forEach((button: HTMLElement): void => {
      button.addEventListener('click', (): void => this.open(button))
    })

    this.closeButton?.addEventListener('click', (): void => this.dialog?.close())

    this.dialog?.addEventListener('click', (event: MouseEvent): void => {
      if (event.target === this.dialog) this.dialog.close()
    })

    this.dialog?.addEventListener('close', (): void => this.onClose())
  }

  private onClose(): void {
    this.activeButton?.setAttribute('aria-expanded', 'false')
    this.activeButton?.focus()
    this.activeButton = null
    this.body?.replaceChildren()
  }

  private open(button: HTMLElement): void {
    const targetId = button.dataset.target
    if (targetId === undefined || this.body === null || this.dialog === null) return

    const template = document.getElementById(targetId) as HTMLTemplateElement | null
    if (template === null) return

    this.activeButton = button
    button.setAttribute('aria-expanded', 'true')
    this.body.replaceChildren(template.content.cloneNode(true))
    this.dialog.showModal()
  }
}

const authorModal = new AuthorModal()
authorModal.init()
